/**
* 控制按钮
*/
<template>
  <div class="components-contrl-bar" style="width:350px;align-items: center;
    justify-content: space-between;">

    <el-page-header @back="cancelFn" title="退出" >
        <div slot="content" style="font-size: 15px;font-weight: bold;cursor: pointer;"  @click="editFn">
            <span style="white-space: nowrap;
            width: 200px;
            overflow: hidden;
            text-overflow: ellipsis;
            vertical-align: middle;
            display: inline-block;">{{projectData.title}}
                    

            </span>
        <i class="el-icon-edit-outline"></i>

        </div>
    </el-page-header>
    
  </div>
</template>

<script>
import { mapState } from "vuex";

	export default {
		components: {
			
    },
		props: {
			// 是否loading
			loading: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
			}
		},
		computed: {
        ...mapState({
                projectData: (state) => state.editor.projectData,
            }),
		},
		created() {

		},
		methods: {
            editFn() {
                this.$emit('edit')
            },
			cancelFn(){
				this.$emit('cancel')
      }
		}
	}
</script>

<style lang="scss" scoped>
  .components-contrl-bar {
    border-left:1px solid #BBB;
    // display: inline-block;
    display:flex;
    align-items: center;
    z-index: 3;
    padding: 2px 12px;
    height: 40px;
    .button-item {
      display: inline-block;
      width: 68px;
      cursor: pointer;
      text-align: center;
      vertical-align: bottom;
      font-size: 14px;
      transition: color 0.28s, transform 0.28s;
      user-select: none;
      &.scale-wrappper {
        width: 110px;
        margin-right: 10px;
        &:hover {
          color: inherit;
          transform: none;
        }
        & > .scale-btn {
          display: inline-block;
          vertical-align: middle;
          padding: 6px 2px;
          font-size: 20px;
          transition: all 0.28s;
          &:hover {
            color: $primary;
          }
        }
      }
      &:hover {
        color: $primary;
        transform: scale(1.02);
        font-weight: bold;
      }
      &.disabled {
        cursor: not-allowed;
        color: $gray !important;
      }
      & > i {
        font-size: 18px;
        display: inline-block;
        transition: all 0.28s;
      }
      & > p {
        font-size: 14px;
      }
    }
  }

  .scale-input {
    display: inline-block;
    position: relative;
    padding: 7px 0;
    width: 46px;
    font-size: 14px;
    text-align: center;
    cursor: pointer;
    white-space: nowrap;
    border-radius: 17px;
    margin: 0 4px;
    &:hover {
      background: #dfdfdf;
    }
  }
</style>
